import { ObservableMedia } from '@angular/flex-layout';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/flex-layout";
var FuseMatchMediaService = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param {ObservableMedia} _observableMedia
     */
    function FuseMatchMediaService(_observableMedia) {
        this._observableMedia = _observableMedia;
        this.onMediaChange = new BehaviorSubject('');
        // Set the defaults
        this.activeMediaQuery = '';
        // Initialize
        this._init();
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Initialize
     *
     * @private
     */
    FuseMatchMediaService.prototype._init = function () {
        var _this = this;
        this._observableMedia.asObservable()
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe(function (change) {
            if (_this.activeMediaQuery !== change.mqAlias) {
                _this.activeMediaQuery = change.mqAlias;
                _this.onMediaChange.next(change.mqAlias);
            }
        });
    };
    FuseMatchMediaService.ngInjectableDef = i0.defineInjectable({ factory: function FuseMatchMediaService_Factory() { return new FuseMatchMediaService(i0.inject(i1.ObservableMedia)); }, token: FuseMatchMediaService, providedIn: "root" });
    return FuseMatchMediaService;
}());
export { FuseMatchMediaService };
